import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // 地图加载状态
        mapLoading: false,
        adcode: 100000,
        map_name: "province",
        level: "province",
        mapHistoryData: [
            {
                adcode: 100000,
                map_name: "province",
                level: "province"
            }
        ]
    },
    mutations: {
        setMapHistoryData: function(state, payload) {
            console.log(payload, 'payload')
            state.mapHistoryData.push(payload);
            state.adcode = payload.adcode
            state.map_name = payload.map_name
            state.level = payload.level
        },
        setValue: function(state, payload) {
            state.adcode = payload.adcode
            state.map_name = payload.map_name
            state.level = payload.level
        },
    },
    actions: {},
    modules: {},
});